module.exports = __webpack_public_path__ + "img/2-light.43f33170.png";